import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { IPageData, UIError } from 'common/interfaces';
import { IDayReportDataStats, IDayReportDateWiseStatus } from 'common/interfaces/idashboard';
import { IACHFormResponse, IRoyaltyReport, IRoyaltyReportsState } from 'common/interfaces/iRoyaltyReports';
import { merge } from 'lodash';

const initialState: IRoyaltyReportsState = {
  loading: false,
  error: undefined,
  selectedFormResponses: undefined,
  reports: undefined,
  updated: undefined,
  ongoingRoyaltyReport: undefined,
  dayReportsStatus: undefined,
};

const reducers = {
  setLoading: (state: IRoyaltyReportsState, action: PayloadAction<boolean>) => {
    state.loading = action.payload;
  },
  setDataLoading: (state: IRoyaltyReportsState, action: PayloadAction<boolean>) => {
    state.loading = action.payload;
  },
  setError: (state: IRoyaltyReportsState, action: PayloadAction<UIError | null>) => {
    state.error = action.payload;
  },
  resetContext: (state: IRoyaltyReportsState) => {
    console.log('Resetting report context');
    merge(state, initialState);
  },

  resetDataUpdated: (state: IRoyaltyReportsState) => {
    state.updated = undefined;
    state.error = undefined;
  },

  setDataUpdated: (state: IRoyaltyReportsState, action: PayloadAction<IACHFormResponse | undefined>) => {
    state.updated = action.payload;
  },

  setDayReportsStatus: (state: IRoyaltyReportsState, action: PayloadAction<IDayReportDateWiseStatus | undefined>) => {
    state.dayReportsStatus = action.payload;
  },

  setReports: (
    state: IRoyaltyReportsState,
    action: PayloadAction<{
      data: IPageData<IRoyaltyReport> | undefined;
      append: boolean;
    }>,
  ) => {
    if (!action.payload.append) {
      state.reports = action.payload.data;
    } else if (action.payload.data) {
      const stReports = state.reports?.items || [];
      const playloadItems = action.payload.data?.items || [];
      state.reports = {
        ...action.payload.data,
        items: [...stReports, ...playloadItems],
      };
    }
  },
  setACHFormResponses: (
    state: IRoyaltyReportsState,
    action: PayloadAction<{
      data: IPageData<IACHFormResponse> | undefined;
      append: boolean;
    }>,
  ) => {
    if (!action.payload.append) {
      state.selectedFormResponses = action.payload.data;
    } else if (action.payload.data) {
      const stReports = state.selectedFormResponses?.items || [];
      const playloadItems = action.payload.data?.items || [];
      state.selectedFormResponses = {
        ...action.payload.data,
        items: [...stReports, ...playloadItems],
      };
    }
  },
  setOngoingReport: (state: IRoyaltyReportsState, action: PayloadAction<IRoyaltyReport | undefined>) => {
    state.ongoingRoyaltyReport = action.payload;
  },
};

const royaltyReportSlice = createSlice({
  name: 'IRoyaltyReportsState',
  initialState: initialState,
  reducers: reducers,
});

export default royaltyReportSlice.reducer;
export const RoyaltyReportActions = royaltyReportSlice.actions;
